export interface ModalStateInterface {
  isLoginModalOpen: boolean;
  isForgotPasswordModalOpen: boolean;
}
export const modalState: ModalStateInterface = {
  isLoginModalOpen: false,
  isForgotPasswordModalOpen: false,
};
